/*
 * Copyright © HatioLab Inc. All rights reserved.
 */

import { getHeadlessPool } from './headless-pool-for-label.js'
import { headlessModel } from './headless-model.js'

/**
 * 라벨 출력
 *
 * @param {String} id 모델 ID
 * @param {Object} data 매핑할 데이터
 * @param {String} orientation (시계방향) N: 0, R: 90, I: 180, B: 270
 * @param {boolean} mirror 좌우반전
 * @param {boolean} upsideDown 상하반전
 */
export const labelcommand = async ({
  id,
  model,
  data,
  orientation,
  mirror = false,
  upsideDown = false,
  context,
  draft = false
}) => {
  const { domain } = context.state

  const browser = (await getHeadlessPool().acquire()) as any
  if (!browser) {
    return
  }

  try {
    const { page } = browser

    var { model } = await headlessModel({ domain, model, id }, draft)

    const grf = await page.evaluate(
      async (model, data, orientation, mirror, upsideDown) => {
        //@ts-ignore
        let s = createScene(model)
        if (data) {
          s.data = data
        }
        return new Promise(resolve => {
          // @ts-ignore
          requestAnimationFrame(() => {
            // @ts-ignore
            let grf = imageDataToGrf(s, model, orientation, mirror, upsideDown)
            resolve(grf)
            // @ts-ignore
            sceneContainer.removeChild(s.target)
            s.dispose()
          })
        })
      },
      model,
      data,
      orientation,
      mirror,
      upsideDown
    )

    return `
^XA
^GFA,${grf}
^FS
^XZ`
  } finally {
    // 에러 발생 시에도 반드시 풀에 브라우저를 반환
    getHeadlessPool().release(browser)
  }
}
